import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/components/atoms/Toast';
import {
	getAiSearch,
	GetAiSearchProps,
	type HttpGetAiSearchResponse
} from '@/services/aiSearchService';
import type { HttpResponseSuccess } from '@/services/service';

type UseAiSearchFormMutationProps = {
	onSuccess: (
		data: HttpResponseSuccess<HttpGetAiSearchResponse>,
		variables: GetAiSearchProps
	) => void;
};

export const useAiSearchFormMutation = ({
	onSuccess
}: UseAiSearchFormMutationProps) => {
	const { toast } = useToast();

	return useMutation({
		mutationKey: ['ai-search-mutation'],
		mutationFn: getAiSearch,
		onSuccess,
		onError: error => {
			// eslint-disable-next-line no-console
			console.error({ error });

			const errorMessage = {
				title: 'Something unexpected happened',
				description: 'Please try again or contact the support'
			};

			toast({
				...errorMessage,
				variant: 'error'
			});
		}
	});
};
